/**
 * Converts tick value to a number to make it comparable to min/max values.
 * @param value - original tick value
 * @returns - Number value or undefined. If the tick value is a date, the corresponding timestamp is returned.
 */
export function getTickValueAsNumber(
  value?: number | string | Date,
): number | undefined {
  if (value === undefined) {
    return value;
  }
  return typeof value === 'number' || typeof value === 'string'
    ? Number(value)
    : value.getTime();
}
